module.exports = __webpack_public_path__ + "static/about-3477700255120c368a926cf7faf00258.jpeg";